export const TYPE_ENTRY_ONLY = "0";
export const TYPE_ENTRY_AND_EXIT = "1";